import { render, staticRenderFns } from "./examManage.vue?vue&type=template&id=2c3572f6&"
import script from "./examManage.vue?vue&type=script&lang=js&"
export * from "./examManage.vue?vue&type=script&lang=js&"
import style0 from "./examManage.vue?vue&type=style&index=0&id=2c3572f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports